import { ModelBase } from '../shared/model.base';

export class ContactRule extends ModelBase {
  name: '';
  contact_period: String;
  contact_period_description: String;
  message_quantity: Number;
  hour_period_init: '';
  hour_period_end: '';
  companyId: number;
  active: false;
  periodCatalogId: number;

  constructor() {
    super();
  }
}
